import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { takeUntil } from 'rxjs/operators';
import { PwaUtilsService } from 'src/services/pwaUtils.service';
import { LoginService } from '@boxx/login-core/lib/services/login.service';
import { LoginStore } from '@boxx/login-core/lib/state/login.store';
import { OnboardingStore } from '@boxx/onboarding-core/lib/state/onboarding.store';
import { DynamicBrandingService } from '@boxx/dynamic-branding/lib/services/dynamic-branding-service';
import { OnboardingService } from '@boxx/onboarding-core/lib/services/onboarding.service';
import { ModalController, NavController } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import { OptionsSupportPage } from '../../options-support/options-support.page';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  destroyed$ = new Subject<boolean>();
  translations: any;

  isPwaView = false;
  selectedItem: number | null;
  breakpointWidth: number;
  accountItemSelected = 0;
  defaultImage: string = 'assets/icon/LateralMenu_ProfileIcon.svg';
  logoUrl: string;
  userName: string;
  businessName: string;
  step = 1;
  businessEmail: string;
  maskEmail: string;
  codeUser: string;
  pass: string;
  confirmPass: string;
  isPassReveal = false;
  isConfirmPassReveal = false;
  brandName: string;

  constructor(public translate: TranslateService,
    private boxxUtils: BoxxUtilsService,
    private pwaUtilsService: PwaUtilsService,
    private router: Router,
    private authSrvc: LoginService,
    public loginStore: LoginStore,
    private storeBusiness: OnboardingStore,
    private dBrandingService: DynamicBrandingService,
    private onboardingService: OnboardingService,
    private navCtrl: NavController,
    private modalCtrl: ModalController) {

    translate.get(['EVENTS_MODULE', 'STORE_MODULE', 'SUPPORT_VIEW', 'FOOD_MODULE', 'ACTIONS', 'SIDEMENU', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    this.selectedItem = null;

    this.storeBusiness.businessConfig.businessData$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((business) => {
        if (!business) {
          return;
        }
        this.businessEmail = (business.emailUser !== undefined && business.emailUser !== null) ? business.emailUser : '';
        if (this.businessEmail !== '') {
          const emailFull = this.businessEmail.split('@');
          this.maskEmail = emailFull[0][0] + '*****@' + emailFull[1];
        }
        this.logoUrl = business.images?.logo_image?.content;
        this.userName = business.name;
        this.businessName = business.businessName;
      });
  }

  ionViewDidEnter() {
    this.step = 1;
    this.setPwaListener();
    //this.firebaseService.setScreenName('SUPPORT');
  }

  ionViewWillEnter() {
    this.brandName = this.dBrandingService.getCurrentBrandName().toUpperCase();
  }

  async openPage(page: number) {
    this.selectedItem = page;
    if (!this.isPwaView) {

      const modal = await this.modalCtrl.create({
        component: OptionsSupportPage,
        componentProps: {
          optionSelected: page
        },

        backdropDismiss: false,
      });

      await modal.present();
    }
  }

  goToPage(page: number) {
    switch (page) {
      case 1:
        this.router.navigateByUrl('/settings');
        break;
      case 2:
        this.router.navigateByUrl('/support/legal');
        break;
      case 3:
        this.router.navigateByUrl('/settings/suscription');
        break;
      case 4:
        this.router.navigateByUrl('/support/change-password');
        break;
      case 5:
        this.router.navigateByUrl('/support/help');
        break;
      case 6:
        this.router.navigateByUrl('/support/preferences');
        break;

      default:
        break;
    }
  }

  openAction(action: number) {

  }

  private setPwaListener() {
    this.breakpointWidth = this.pwaUtilsService.getBreakpointWidth();
    this.pwaUtilsService.reportWindowResize$.subscribe((dimensions) => {
      const rightPane = document.getElementById('contacts-right-pane');
      const leftPane = document.getElementById('contacts-left-pane');
      if (dimensions.width < this.breakpointWidth) {
        this.isPwaView = false;
      } else {
        this.isPwaView = true;
      }
    });
  }

  back() {
    this.navCtrl.back();
    //this.router.navigateByUrl('/tabs/more');
  }

  deleteAccount() {
    this.boxxUtils.showAlert({
      header: this.translations.SIDEMENU.DELETE_ACCOUNT_ALERT.header,
      message: this.translations.SIDEMENU.DELETE_ACCOUNT_ALERT.message,
      animated: true,
      buttons: [
        {
          text: this.translations.ACTIONS.delete,
          role: 'destructive',
          handler: () => {
            this.boxxUtils.handleLoading(true);
            this.authSrvc
              .deleteAccount()
              .then(async (resp: any) => {
                this.boxxUtils.handleLoading(false);
                this.boxxUtils.showToastSuccess({
                  message: this.translations.SIDEMENU.MESSAGES.success,
                });
                await this.router.navigateByUrl('/login');
              })
              .catch((error) => {
                this.boxxUtils.showToastSuccess({
                  message: this.translations.SIDEMENU.MESSAGES.error,
                });
                this.boxxUtils.handleLoading(false);
              });
          },
        },
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
      ],
    });
  }

  openAccountItem(item: number) {
    this.accountItemSelected = item;

    if (item === 1) {
      this.step = 1;
      this.sendendCode();
    }
  }

  sendendCode() {
    this.boxxUtils.handleLoading(true);
    this.onboardingService.sendPasswordCode({ email: this.businessEmail })
      .subscribe((data) => {
        this.boxxUtils.handleLoading(false);
      },
        (error) => {
          this.boxxUtils.handleLoading(false);
        });
  }

  async doLogout() {
    this.boxxUtils.showAlert({
      header: this.translations.SIDEMENU.LOGOUT_ALERT.header,
      message: this.translations.SIDEMENU.LOGOUT_ALERT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.ok,
          role: 'destructive',
          handler: () => {
            this.loginStore.logout();
            this.modalCtrl.dismiss();
            this.router.navigateByUrl('welcome');
          },
        },
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
      ],
    });
  }

  validateCode() {
    this.boxxUtils.handleLoading(true);
    this.onboardingService.validatePasswordCode({ email: this.businessEmail, verification_code: this.codeUser })
      .subscribe((data) => {
        this.codeUser = '';
        this.boxxUtils.handleLoading(false);
        this.step = 2;
      },
        (error) => {
          this.boxxUtils.showToastError({
            message: this.translations.SUPPORT_VIEW.PASSWORD_UPDATE.errorCode
          });
          this.boxxUtils.handleLoading(false);
        });
  }

  updatePass() {
    this.boxxUtils.handleLoading(true);
    this.onboardingService.updatePassword({ email: this.businessEmail, password: this.pass, confirm_password: this.confirmPass })
      .subscribe((data) => {
        this.pass = '';
        this.confirmPass = '';
        this.boxxUtils.showToastSuccess({
          message: this.translations.SUPPORT_VIEW.PASSWORD_UPDATE.successPassword
        });
        this.boxxUtils.handleLoading(false);
        this.step = 1;
        this.accountItemSelected = 0;
      },
        (error) => {
          this.boxxUtils.showToastError({
            message: this.translations.SUPPORT_VIEW.PASSWORD_UPDATE.errorCode
          });
          this.boxxUtils.handleLoading(false);
        });
  }

  closeAccountItem() {
    this.accountItemSelected = 0;
  }

  async openPrivacy() {
    const _url = ((this.dBrandingService.privacyUrl && this.dBrandingService.privacyUrl !== '#') ? this.dBrandingService.privacyUrl : 'https://myboxx.app/aviso-de-privacidad/');
    await Browser.open({ url: _url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  async openTos() {
    const _url = ((this.dBrandingService.termsUrl && this.dBrandingService.termsUrl !== '#') ? this.dBrandingService.termsUrl : 'https://myboxx.app/terms-user-boxx/');
    await Browser.open({ url: _url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  revealPass() {
    this.isPassReveal = !this.isPassReveal;
  }

  revealConfirmPass() {
    this.isConfirmPassReveal = !this.isConfirmPassReveal;
  }

}
